export const enum CAR_OVERVIEW {
  lowKm = 'low_kilometres',
  lowKmPerYear = 'low_kilometres_per_year',
  recentlyServiced = 'recently_serviced',
  regoRemaining = 'rego_remaining',
  singleOwner = 'single_owner',
  fullSpareTyre = 'full_spare_tyre',
  twoNewTyres = '2_new_tyres',
  fourNewTyres = '4_new_tyres',
}
